import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';
import NavigationSelector from '../../../components/ParametersPage/Navigation';

const mapStateToProps = (state: StoreState) => {
	const { displayType } = state.driveList;
	return { displayType };
};

export default connect(mapStateToProps)(NavigationSelector);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ParametersPage/Navigation/index.tsx